import styled from "@emotion/styled";

import { SkiliticsLogo } from "@skilitics/designer-theme";
import { SkiliticsLogoIcon } from "@skilitics/designer-ui-components";

import { privacyPolicyLink, termsOfUseLink } from "../../../auth/ui/shared";

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: ${({ theme }) => theme.generalTextIcon};
  background: ${({ theme }) => theme.surface};
  width: 100%;
  padding-top: 15px;
  border-top: 1px solid ${({ theme }) => theme.surfaceSoft};
  height: 44px;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Logo = styled(SkiliticsLogoIcon)`
  height: 100%;
  width: auto;
  margin-right: 8px;
`;
const SkiliticsText = styled(SkiliticsLogo)`
  height: auto;
  width: 76px;
`;

const StyledLink = styled.a`
  color: inherit;
  display: inline;
  width: 100%;
  text-align: center;
  padding: 0;
  margin: 0 0 10px;
`;

const LegalLinksContainer = styled.div`
  font-size: 10px;
  text-align: right;
`;

export const LandingPageFooter = () => (
  <FooterContainer>
    <LogoContainer>
      <Logo />
      <SkiliticsText />
    </LogoContainer>
    <LegalLinksContainer>
      <StyledLink href={termsOfUseLink} target="_blank" rel="noopener">
        Terms of Use
      </StyledLink>{" "}
      &amp;{" "}
      <StyledLink href={privacyPolicyLink} target="_blank" rel="noopener">
        Privacy
      </StyledLink>
    </LegalLinksContainer>
  </FooterContainer>
);
